var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 20,
    viewBox: "0 0 72 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3976 4.58501C21.5976 2.98501 32.7309 3.91834 37.8976 4.58501C37.8976 21.0851 20.9648 20 10.3978 18.585C-1.49563 16.9924 -4.10285 1.08497 7.3976 0.0849779C19.136 -0.935698 10.8971 7.58495 10.8971 7.08499C10.8971 4.89189 9.46484 2.08496 6.46484 4.58501C2.92354 7.53616 7.35622 11.085 10.3976 11.085C13.398 11.085 14.3976 6.58501 18.3976 4.58501Z",
    className: "Mouth"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3977 4.67003C50.1977 3.07003 39.0644 4.00337 33.8977 4.67003C33.8977 21.1701 49.9648 20 61.3975 18.67C73.3167 17.2835 75.8982 1.16999 64.3977 0.17C52.6594 -0.850676 60.8982 7.66997 60.8982 7.17001C60.8982 4.97691 61.9648 2.16998 64.9648 4.67003C68.5061 7.62118 64.4391 11.17 61.3977 11.17C58.3974 11.17 57.3977 6.67003 53.3977 4.67003Z",
    className: "Mouth"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthP);
export default __webpack_public_path__ + "static/media/Mouth P.a3d8e0de4ca5302e0024ee38de62f0ae.svg";
export { ForwardRef as ReactComponent };